import { AppConfigGen } from './AppConfigGen'

export const AppConfig = {
  ...AppConfigGen,
  MAX_DOCUMENT_UPLOAD_SIZE: 20000000,
  ORG_SEARCH_LIMIT: 10000,
  // ENDPOINT : 'http://127.0.0.1:3000',
  DRAWER_STYLE: 'TYPE2',
  CUSTOM_STYLE_COMP: ['TableComponent', 'AppButton', 'MultiSelectFilterBar', 'SearchBar', 'SearchBarVenues', 'DynamicFormDialog', 'DynamicForm', 'emptyView', 'ImageUploader', 'CustomAssetPickerStyles', 'SubEntityCard', 'CampaignAdvertiser', 'DocumentUploader', 'SingleSelectDropDown', 'BreadCrumbs', 'SearchBox'],
  LOGO: require('./assets/images/logo.png'),
  ALLOWMOCK: false,
  VERSION: '1.0.209',
  BRANDCOLOURS: ['#FFFFFF', '#000000', '#ff0000', '#FFFF00', '#0000FF'],
  TERMS: 'https://dolphin-digital.com/terms',
  PRIVACY: 'https://dolphin-digital.com/terms',
  FEATURES_OFF:[
    // 'CAMPAIGN_SCHEDULE',
    // 'ASSET_WEBLINK',
    'SEND_COMMAND_TO_SCREEN',
    // 'DISPLAY_ADS_PLAYER',
    // 'BULK_ATTACH_DETACH_VENUE',
    // 'GENERATE_VIDEO_THUMBNAIL'
  ],
  PRODUCTION_HOST:'manage.dolphin-digital.com',
  WS: {
    // dev endpoints
    // ENDPOINT: 'wss://7hla7qik62.execute-api.us-east-1.amazonaws.com/prod/',
    // API_KEY: 'GEdPUzF3MP4JOe8oiSjso1YWuNIBCntB51gzeFW3'
    // prod endpoints
    ENDPOINT: 'wss://rkhreuxang.execute-api.us-east-1.amazonaws.com/prod/',
    API_KEY: 'ws-6e80a174-c9bd-46f9-bbab-ecdcfde20be8'
  },
  DEFAULT_MAP_LOCATION: {
    LAT: 40.7127753,
    LNG: -74.0059728,
    NAME: 'New York, NY, USA'
  },
  DASHBOARD_WEB_LINK: 'https://manage.dolphin-digital.com',
  DASHBOARD_COMMON_TITLE: 'OOH Management Console',
  DAYPARTING_SCREENS: ['DD-HOMTWQ', 'DD-HGRR3R','DD-HS8B4G','DD-HOKOYU','DD-H1PGV9', 'DD-H9WARL', 'DD-790AA9', 'DD-HDJ468','DD-HVB1IS','DD-H7UPXF','DD-HB3BGQ','DD-HVGGDC','DD-HRVEIA','DD-HJ7HGJ','DD-H8KRZ0','DD-H0Z0FD','DD-H7IFME','DD-746493','DD-A03518','DD-HWDBF8','DD-H4JW9F','DD-H3QMVN','DD-F2EF14','DD-AA1FC5','DD-HYTQNK','DD-H43R9B','DD-H0XE8L','DD-HDQNCX','DD-H9067W','DD-HO8400','DD-04F254','DD-HW2Z6P','DD-H2JC8A','DD-H1WDIY'] //'DD-5A2A18'
}



// WEBPACK FOOTER //
// ./src/AppConfig.js